export const vehicleModes = ['Self Bike', 'Self Car', 'Pillion on bike', 'Co-passenger in car'];

export const comfortableOptions = ['Yes', 'No'];

export const trnOptions = ['With transport', 'Without transport'];

export const isGroupOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
];
